import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import Link from 'react-router-dom/Link';
import { StyleSheet, css } from 'aphrodite';



@autobind
class Footer extends React.Component {
  state = {
    onLocalHost: false,
    openLegal:false,
    openSocial:false,
    openContact:false,
  };

  componentDidMount(){
    if(window.location.hostname.search("localhost")) this.setState({onLocalHost:true});
  }

  render() {
    return (
      <div className={css(styles.MainWrapper)}>
        <div className={css(styles.Wrapper)}>
          <div className={css(styles.Flex)}>
            <div className={css(styles.Flex1)}>
              <Link to="/" className={css(styles.A)}>
                <img className={css(styles.Logo)} src="../assets/logo.svg" alt="minimaa logo" />
              </Link>
              <div className={css(styles.Copyright)}>COPYRIGHT © 2020 MINIMAA</div>
            </div>
            <div className={css(styles.Flex2)}>
              <div className={css(styles.Flex211Wrapper)}>
                <div className={css(styles.Title)} onClick={()=>this.setState({openLegal:!this.state.openLegal})}>
                  TOUR
                  <img alt="arrow down" className={this.state.openLegal ? css(styles.OpenButton) : css(styles.CloseButton)} src="../assets/arrDown.svg" />
                </div>
                <div className={this.state.openLegal ? css(styles.Flex21Open) : css(styles.Flex21Close)}>
                  <Link onClick={()=>window.scrollTo(0,0)} className={css(styles.CategoryName)} to="/pricing">
                      PRICING
                  </Link>
                  <Link onClick={()=>window.scrollTo(0,0)} className={css(styles.CategoryName)} to="/privacy-policy">
                      PRIVACY POLICY
                  </Link>
                  <Link onClick={()=>window.scrollTo(0,0)} to="/terms-of-service" className={css(styles.CategoryName)}>
                      TERMS OF SERVICE
                  </Link>
                </div>
              </div>
              <div className={css(styles.Flex21Wrapper)}>
                <div className={css(styles.Title)} onClick={()=>this.setState({openSocial:!this.state.openSocial})}>FOLLOW US
                  <img alt="arrow down" className={this.state.openSocial ? css(styles.OpenButton) : css(styles.CloseButton)} src="../assets/arrDown.svg" open={this.state.openSocial} />
                </div>
                <div className={this.state.openSocial ? css(styles.Flex21Open) : css(styles.Flex21Close)}>
                  <a className={css(styles.CategoryName)} target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/minimaa.co">
                    INSTAGRAM
                  </a>
                  <a className={css(styles.CategoryName)} target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/minimaa.co">
                    FACEBOOK
                  </a>
                  <a className={css(styles.CategoryName)} target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/company/19113676">
                    LINKEDIN
                  </a>
                </div>
              </div>
              <div className={css(styles.Flex21Wrapper)}>
                <div className={css(styles.Title)} onClick={()=>this.setState({openContact:!this.state.openContact})}>SAY HELLO
                  <img alt="arrow down" className={this.state.openContact ? css(styles.OpenButton) : css(styles.CloseButton)} src="../assets/arrDown.svg" open={this.state.openSocial} />
                </div>
                <div className={this.state.openContact ? css(styles.Flex21Open) : css(styles.Flex21Close)} open={this.state.openSocial}>
                  <a className={css(styles.CategoryName)} target="_blank" rel="noopener noreferrer" href="mailto:hello@minimaa.co">
                    HELLO@MINIMAA.CO
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const styles = StyleSheet.create({
  
MainWrapper:{
  background:"#000",
  width:"100%",
},
Wrapper:{
  maxWidth:950,
  margin:"0px auto",
  width:"calc(100% - 440px)",
  marginTop:50,
  background:"#000",
  '@media (max-width: 1400px)': {
   width:"calc(100% - 380px)",
   maxWidth:1050,
  },
  '@media (max-width: 1300px)': {
    width:"calc(100% - 280px)",
  },
  '@media (max-width: 1150px)': {
    width:"calc(100% - 150px)",
  },
  '@media (max-width: 1020px)': {
    width:"100%",
    borderRadius:0,
    marginBottom:0,
  },
},

Copyright:{
  color:"#A3A3A3",
  fontSize:12,
  height:"calc(100% - 18px)",
  display:"flex",
  fontWeight:500,
  alignItems:"flex-end",
  textAlign:"left",
  lineHeight:1.4,
  minHeight:90,
  justifyContent: 'flex-end',
  flexDirection:"column",
  '@media (max-width: 1020px)': {
    alignItems:"center",
    minHeight:35,
  },
},
Flex:{
  display:"flex",
  margin:"0 auto",
  paddingTop:65,
  paddingBottom:65,
  width: "100%",
  alignItems:"stretch",
  justifyContent: 'space-between',
  '@media (max-width: 1020px)': {
    flexDirection:"column-reverse",
    alignItems:"center",
    height:"auto",
    paddingTop:50,
    paddingBottom:50,
  }
},
Flex1:{
  '@media (max-width: 1020px)': {
    marginTop:50,
  }
},
Flex2:{
  display:"flex",
  width:"auto",
  minWidth:"40%",
  alignItems:"flex-start",
  justifyContent: 'space-between',
  '@media (max-width: 1020px)': {
    flexDirection:"column",
    minWidth:"auto",
  }
},
Flex21Wrapper:{
  marginLeft:70,
  '@media (max-width: 1020px)': {
    borderBottom:"1px solid #A3A3A3",
    marginBottom:30,
    marginLeft:0,
    width:240,
  }
},
Flex211Wrapper:{
  marginRight:100,
  '@media (max-width: 1020px)': {
    borderBottom:"1px solid #A3A3A3",
    marginBottom:30,
    marginLeft:0,
    marginRight:0,
    width:240,
  }
},
OpenButton:{
  display:"none",
  '@media (max-width: 1020px)': {
    display:"block",
    width:18,
    filter:"invert(0.5)",
    transition:"0.5s",
    transform:"rotate(180deg)",   
  }
},
CloseButton:{
  display:"none",
  '@media (max-width: 1020px)': {
    display:"block",
    width:18,
    filter:"invert(0.5)",
    transition:"0.5s",
    transform:"rotate(0deg)",   
  }
},
Flex21Open:{
  display:"flex",
  alignItems:"flex-start",
  justifyContent: 'flex-start',
  flexDirection:"column",
  flexWrap:"wrap",
  maxHeight:150,
  '@media (max-width: 1020px)': {
    transition:"opacity 0.5s 0.2s, max-height 0.2s" ,
    alignItems:"flex-start",
    marginBottom:10,
    opacity:1,
    maxHeight:300,
    overflow:"hidden",
    paddingBottom:5,
  }
},
Flex21Close:{
  display:"flex",
  alignItems:"flex-start",
  justifyContent: 'flex-start',
  flexDirection:"column",
  flexWrap:"wrap",
  maxHeight:150,
  '@media (max-width: 1020px)': {
    transition:"padding 0.2s 0.2s, margin 0.2s 0.2s, opacity 0.3s, max-height 0.2s 0.2s",
    alignItems:"flex-start",
    marginBottom:0,
    opacity:0,
    maxHeight:0,
    overflow:"hidden",
    paddingBottom:10,
  }
},




Title:{
  color:"#fff",
  fontSize:12,
  display:"flex",
  justifyContent:"space-between",
  alignItems:"center",
  fontWeight:500,
  paddingBottom:12,
  userSelect:"none",
  '@media (max-width: 1020px)': {
    cursor:"pointer",
    paddingBottom:0,
  },
  '@media (max-width: 420px)': {
      fontSize:14,
    }
},
CategoryName:{
  letterSpacing: "0.190909px",
  color:"#A3A3A3",
  fontSize:12,
  whiteSpace: "nowrap",
  marginTop:12,
  fontWeight:500,
  display:"block",
  cursor:"pointer",
  userSelect: "none",
  textDecoration:"none",
  '@media (max-width: 850px)': {
    marginRight:20,
  },
  '@media (max-width: 420px)': {
      fontSize:14,
    }
},





A:{
  textDecoration:"none",
  position:"relative",
  color:"black",
  fontSize:20,
  whiteSpace:"nowrap",
  filter: "invert(1)",
  cursor:"pointer",
  fontWeight:600,
  transition:"0.3s",
  display:"flex",
  alignItems:"center",
  justifyContent: 'flex-start',
  '@media (max-width: 1020px)': {
    justifyContent: 'center',
  }
},

LinksWrapper:{
  display:"flex",
  alignItems:"center",
  justifyContent: 'space-between',
  '@media (max-width: 1020px)': {
    flexDirection:"column",
    paddingBottom:20,
  }
},

FooterLinks:{
  textDecoration:"none",
  color: "#fff",
  cursor:"pointer",
  padding: 4,
  whiteSpace: "nowrap",
  letterSpacing: "0.62px",
  fontSize:11,
  margin:"0 10px",
  fontWeight:500,
  webkitTransition:"0.3s",
  transition:"0.3s",
  display:"block",
  ":hover":{
    opacity:0.7,
  },
  '@media (max-width: 1020px)': {
    flexDirection:"column",
    margin:"5px 0",
    fontSize:12,
  }
},

  Logo:{
    width:115,
    marginRight:10,
  },
})

export default Footer;